// extracted by mini-css-extract-plugin
export default {"form":"style_form__o9pPU","errorText":"style_errorText__vFqru","submit":"style_submit__4hil7","inputLabel":"style_inputLabel__AcxQz"};